import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {AttachmentData} from '@docma-mm-core/attachment/attachment';
import {BehaviorSubject} from 'rxjs';
import {UntilDestroy} from '@ngneat/until-destroy';
import {MmAddAttachmentsFormService} from './mm-add-attachments.form.service';
import {DeviceService} from "@mydocma/core/src/lib/device";

@UntilDestroy()
@Component({
  selector: 'mydocma-mm-add-attachments-form',
  templateUrl: './mm-add-attachments-form.component.html',
  styleUrls: ['./mm-add-attachments-form.component.scss'],
  providers: [MmAddAttachmentsFormService]
})
export class MmAddAttachmentsFormComponent implements OnInit, OnChanges, OnDestroy {

  @Input()
  attachmentData = new AttachmentData();

  @Input()
  filesIn: File[];

  filesChangedSubject: BehaviorSubject<File[]> = new  BehaviorSubject<File[]>(null);
  filesChanged$ = this.filesChangedSubject.asObservable();

  descriptionExpanded = false;
  files = [];
  acceptedTypes: Array<string>;
  attachmentsForm: UntypedFormGroup;

  mobileMode = false;

  constructor(public readonly addAttachmentsFormService: MmAddAttachmentsFormService, private deviceService: DeviceService) {
    this.loadForm();
   }

   ngOnDestroy(): void {
  }

  ngOnInit() {
    this.mobileMode = !this.deviceService.isDesktop();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.attachmentData) {
      this.addAttachmentsFormService.loadAttachment(changes.attachmentData as AttachmentData)
      this.loadForm();
    }

    if (changes.filesIn) {
      const files: File[] = this.filesIn;
      this.onFilesAdded(files);
    }
  }

  private loadForm() {
    this.addAttachmentsFormService.loadAttachment(this.attachmentData)
    this.files = [];
    this.attachmentsForm = new UntypedFormGroup({
        files: new UntypedFormControl(null, Validators.required)
      });
  }

  reset() {
    this.attachmentData = new AttachmentData();
    this.addAttachmentsFormService.loadAttachment(this.attachmentData)
    this.loadForm();
  }

  validate(): boolean {
    if (!this.attachmentsForm.valid) {
      this.attachmentsForm.markAllAsTouched();
      return false;
    }
    return true;
  }

  isChanged() {
    return (this.attachmentsForm.dirty || this.attachmentsForm.pristine);
  }

  submit(): {attachmentData: AttachmentData, files: File[]} {
    if (!this.validate()) {
       return null;
    }
    const attachmentData = this.addAttachmentsFormService.getChanges();
    return {attachmentData, files: this.files};
  }

  onFileDeleted(event: any) {
    this.files.splice(event.index, 1);
    this.files = [ ...this.files];
    if (this.files.length === 0) {
      this.attachmentsForm.patchValue({files: null});
    } else {
      this.attachmentsForm.patchValue({files: this.files});
    }
    this.filesChangedSubject.next(this.files);
  }

  onFilesAdded(fileList: File[]) {
    this.files = [ ...this.files];
    this.files.push(...fileList);
    this.attachmentsForm.patchValue({files: this.files});
    this.filesChangedSubject.next(this.files);
  }
}
